module.exports = __webpack_public_path__ + "img/button_circle_download.47d3e23e.svg";